import clsx from 'clsx';
import A from 'components/atoms/A/A';
import Button from 'components/atoms/Button/Button';
import { ProgressBar } from 'components/atoms/ProgressBar/ProgressBar';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import { graphql, useFragment } from 'react-relay';
import useLiveFragment from 'relay/useLiveFragment';
import classes from './RedeemBanner.module.scss';
import { RedeemBanner_balance$key } from './__generated__/RedeemBanner_balance.graphql';
import { RedeemBanner_target$key } from './__generated__/RedeemBanner_target.graphql';

export interface Props {
  className?: string;
  balanceRef: RedeemBanner_balance$key;
  targetRef: RedeemBanner_target$key;
}

const balanceFragmentSpec = graphql`
  fragment RedeemBanner_balance on WalletBalance
  @refetchable(queryName: "RedeemBannerBalanceRefetchQuery") {
    amount {
      formatted
      subUnitAmount
    }
  }
`;

const targetFragmentSpec = graphql`
  fragment RedeemBanner_target on AmountDenomination {
    panelistCost {
      subUnitAmount
    }
    redemptionAmount {
      formatted
    }
  }
`;

const RedeemBanner: React.FC<Props> = ({ balanceRef, targetRef, className }) => {
  const walletBalance = useLiveFragment(balanceFragmentSpec, balanceRef);
  const targetAmount = useFragment(targetFragmentSpec, targetRef);
  if (!walletBalance || !targetAmount) return <></>;

  const balance = walletBalance.amount.subUnitAmount;
  const formattedBalance = walletBalance.amount.formatted;
  const targetPoints = targetAmount.panelistCost.subUnitAmount;
  const targetReward = targetAmount.redemptionAmount.formatted;

  return (
    <div className={clsx(classes.root, className)}>
      <Txt className={clsx(classes.points)} skipTranslation>
        {formattedBalance}
      </Txt>
      {balance >= targetPoints ? (
        <Txt className={clsx(classes.action)}>
          You&apos;re ready to redeem
          <Button
            component={A}
            href={'/rewards'}
            className={clsx(classes.redeemButton)}
            buttonSize="large"
          >
            Redeem
          </Button>
        </Txt>
      ) : (
        <Txt className={clsx(classes.action)}>
          Collect {{ needed: targetPoints - balance }} more to redeem {{ money: targetReward }}
        </Txt>
      )}

      <ProgressBar
        className={clsx(classes.progressBar)}
        style={'linear'}
        value={balance}
        max={targetPoints}
      />
    </div>
  );
};

export default RedeemBanner;
